module.exports = __webpack_public_path__ + "static/media/see_collection_arrow.b587f91e.svg";